var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9535 1.23664C12.0585 0.341691 10.6075 0.341693 9.71255 1.23664L8.83301 2.11619L13.8836 7.16674L14.7631 6.28719C15.6581 5.39224 15.6581 3.94124 14.7631 3.04629L12.9535 1.23664Z",
    fill: "#033272"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9997 8.05062L7.94913 3.00007L1.37922 9.56998C0.94945 9.99975 0.708008 10.5826 0.708008 11.1904V14.6667C0.708008 15.0119 0.98783 15.2917 1.33301 15.2917H4.80932C5.41711 15.2917 6 15.0503 6.42977 14.6205L12.9997 8.05062ZM2.99967 9.71729L6.28246 13.0001L5.54589 13.7366C5.35054 13.932 5.08559 14.0417 4.80932 14.0417H3.67523L1.95801 12.3245V11.1904C1.95801 10.9142 2.06775 10.6492 2.2631 10.4539L2.99967 9.71729Z",
    fill: "#033272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.0cde4ac6c851caf35b69584a7efb33f3.svg";
export { ForwardRef as ReactComponent };